import run from '../../utilities/run';
import render from '../../utilities/render';
import FamfLogic from './famfLogic';

const targetSelector = "#fedex-accounts-management-form";

 // For quick dev prototyping
run(targetSelector, (outerEl)=>{
  attachHtml(outerEl);
});

function attachHtml(outerEl){
  const famfLogicVar = new FamfLogic(outerEl);
  famfLogicVar.init();
};



// WEBPACK FOOTER //
// ./src/pages/fedexAccountManagement/famf.js